import Component from 'flarum/common/Component';
/**
 * BlueEmotion · section hero.
 *
 * A slim, brand-consistent page header that shows just a page title (and an
 * optional subtitle) sitting directly on the Bone page. It reuses the exact
 * atmosphere of the index WelcomeHero — ambient Glow-Blue radial + the civic
 * line-art strip — so listing pages (Discussions, Polls) share one look.
 *
 * Styling lives in less/forum/Hero.less under the shared `.Hero.SectionHero`
 * selectors. The base `Hero` class is kept on the root so IndexPage's
 * hero-height scroll-preservation logic (which measures `.Hero`) keeps working.
 */
export default class SectionHero extends Component {
  view() {
    const _this$attrs = this.attrs,
      title = _this$attrs.title,
      subtitle = _this$attrs.subtitle;
    return m("header", {
      className: "Hero SectionHero"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "containerNarrow"
    }, m("h1", {
      className: "Hero-title"
    }, title), subtitle ? m("p", {
      className: "Hero-subtitle"
    }, subtitle) : null)));
  }
}
flarum.reg.add('glowingblue-demo', 'forum/components/SectionHero', SectionHero);